import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import TemplateDetails from '../../components/OrderDetails/TemplateDetails'

function TemplateDetailsPage() {
    return (
        <>
            <Helmet>
                <title>Order Details</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            <TemplateDetails />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default TemplateDetailsPage;

